import React from 'react';
import { Box, ButtonProps } from '@material-ui/core';
import FsAbsoluteCircularProgress from 'ui-elements/loaders/FsAbsoluteCircularProgress/FsAbsoluteCircularProgress';
import FsButton from 'ui-elements/buttons/FsButton';

export type FsPendingButtonProps = ButtonProps & {
  pending: boolean;
  width?: number;
  spaceBetween?: boolean;
};

const FsPendingButton: React.FC<FsPendingButtonProps> = ({
  onClick,
  pending,
  startIcon,
  children,
  width,
  fullWidth,
  spaceBetween,
  ...otherButtonProps
}) => {
  return (
    <Box
      display="inline-block"
      position="relative"
      style={{
        width: fullWidth ? '100%' : undefined,
      }}
    >
      <FsButton
        color="primary"
        variant="contained"
        {...{ ...otherButtonProps, fullWidth }}
        startIcon={startIcon}
        onClick={onClick}
        style={{
          boxSizing: 'border-box',
          width,
          display: spaceBetween ? 'flex' : undefined,
          alignItems: spaceBetween ? 'center' : undefined,
          justifyContent: spaceBetween ? 'space-between' : undefined,
          paddingLeft: spaceBetween ? 24 : undefined,
          paddingRight: spaceBetween ? 24 : undefined,
        }}
      >
        {children}
      </FsButton>
      {pending && <FsAbsoluteCircularProgress size={24} />}
    </Box>
  );
};

export default FsPendingButton;
